import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CustomGiftCardsListState, GIFT_CARD_FEATURE, StateWithGiftCards } from '../custom-gift-card-state';


export const getGiftCardListState: MemoizedSelector<
StateWithGiftCards,
CustomGiftCardsListState
> = createFeatureSelector<CustomGiftCardsListState>(GIFT_CARD_FEATURE);
